import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardHeader, CardContent, CardActions, Collapse, Avatar, IconButton, Typography } from '@material-ui/core';
import clsx from 'clsx';
import Constants from '../../common/constants';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SubjectIcon from '@material-ui/icons/Subject';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 300,
    maxWidth: 300,
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
}));

const CategoryCard = ({ cardTitle, categoryGroup, totalCount, categories }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const renderCategoryDetails = () => {
    let categoryDetail = categories.map((category) => {
      return (
        <div className="row" key={category.categoryGroup}>
          <div className="col-md-10">
            <Typography
              variant="subtitle2"
            >
              {category.categoryGroup}
            </Typography>
          </div>
          <div className="col-md-2">
            <Typography
              variant="subtitle2"
            >
              {category.totalCount}
            </Typography>
          </div>
        </div>
      )
    });
    return categoryDetail;
  }

  return (
    <Card className={classes.root}>
      <CardHeader
        avatar={
          <Avatar style={
            categoryGroup === Constants.Category.Shop ? { backgroundColor: '#ffb181', width: 20, height: 20 } :
              categoryGroup === Constants.Category.EatAndDrink ? { backgroundColor: '#9ae681', width: 20, height: 20 } :
                categoryGroup === Constants.Category.Play ? { backgroundColor: '#83d5fe', width: 20, height: 20 } :
                  categoryGroup === Constants.Category.TravelAndServices ? { backgroundColor: '#ffa0d7', width: 20, height: 20 } :
                    categoryGroup === Constants.Category.Relax ? { backgroundColor: '#c686fe', width: 20, height: 20 }
                      : { backgroundColor: '#FFFFFF' }}>
            <SubjectIcon hidden />
          </Avatar>
        }
        title={<Typography variant="caption">{cardTitle}</Typography>}
        subheader={<Typography variant="subtitle2">{categoryGroup}</Typography>}
      />
      <CardContent>
        <center>
          <Typography variant="h2" color="textSecondary" component="p">
            {totalCount}
          </Typography>
        </center>
      </CardContent>
      <CardActions disableSpacing>
        <IconButton
          disabled={totalCount > 0 ? false : true}
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <Typography variant="caption">
            Categories in {categoryGroup}
          </Typography>
          <hr />
          {renderCategoryDetails()}
        </CardContent>
      </Collapse>
    </Card>
  );
}

export default CategoryCard;